import { createAppByPlatform } from '@/create-app/createAppIs24';
import { createAuth0Instance } from '@/helpers/Auth/authClient';
import { initDatadogRUM } from '@/helpers/RUMService/RUMService';
import {
  captureSsrPiniaSnapshot,
  restorePiniaFromSsrSnapshot,
  verifySsrHandoff,
} from '@/helpers/ssrHandoff';
import { i18n } from '@/i18n-setup';
import App from './AppIs24.vue';
import scrollIntoView from './directives/scrollIntoView';

import('@smg-real-estate/acr-injection/umd');

(async () => {
  captureSsrPiniaSnapshot();

  const { app, router, pinia } = await createAppByPlatform(App);

  app.directive('scroll-into-view', scrollIntoView);

  initDatadogRUM();

  const piniaState = window.__PINIA_STATE__;
  if (piniaState) {
    restorePiniaFromSsrSnapshot(pinia, piniaState);
  }

  const auth0 = createAuth0Instance();
  if (auth0) {
    app.use(auth0 as any);
  }

  await router.isReady();

  verifySsrHandoff({
    pinia,
    router,
    locale: i18n.global.locale.value,
  });

  app.mount('#app');
})();
